import { FC } from 'react'
import { Link } from 'react-router-dom'
import { DictionaryModel } from '../../../models/responses/DictionaryModel'
import { KTSVG } from '../../../_metronic/helpers'
import { TableHelperButtonEnum } from '../../enums/TableHelperButtonEnum'

type Props = {
  itemId?: any
  itemParam?: string
  links?: DictionaryModel[]
  types: Array<string>
  onClickItem: (itemId: string, itemName: string, type: string) => void
}
const TableHelperButtons: FC<Props> = ({ itemId, itemParam, links, types, onClickItem }) => {
  return (
    <div className='d-flex justify-content-end flex-shrink-0'>
      {links?.map((item, i) => {
        return (
          <Link
            key={i}
            to={item.value}
            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
          >
            <i className={`fas fa-${item.type} text-gray-500`} ></i>
          </Link>
        )
      })}
      {types.find((i) => i == TableHelperButtonEnum.View) && (
        <a
          href='#'
          onClick={() => onClickItem(itemId!!, itemParam!!, TableHelperButtonEnum.View)}
          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
        >
          <KTSVG path='/media/icons/duotone/General/Visible.svg' className='svg-icon-1' />
        </a>
      )}
      {types.find((i) => i == TableHelperButtonEnum.Update) && (
        <a
          href='#'
          onClick={() => onClickItem(itemId!!, itemParam!!, TableHelperButtonEnum.Update)}
          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
        >
          <KTSVG path='/media/icons/duotone/Communication/Write.svg' className='svg-icon-3' />
        </a>
      )}
      {types.find((i) => i == TableHelperButtonEnum.Reply) && (
        <a
          href='#'
          onClick={() => onClickItem(itemId!!, itemParam!!, TableHelperButtonEnum.Reply)}
          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
        >
          <KTSVG path='/media/icons/duotone/Communication/Chat.svg' className='svg-icon-3' />
        </a>
      )}
      {types.find((i) => i == TableHelperButtonEnum.Delete) && (
        <a
          href='#'
          onClick={() => onClickItem(itemId!!, itemParam!!, TableHelperButtonEnum.Delete)}
          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
        >
          <KTSVG path='/media/icons/duotone/General/Trash.svg' className='svg-icon-3' />
        </a>
      )}
    </div>
  )
}

export { TableHelperButtons }
